export var LogKind;
(function (LogKind) {
    LogKind["Info"] = "Info";
    LogKind["Error"] = "Error";
    /**
     * Engagement/Analytics logging
     */
    LogKind["Analytics"] = "Analytics";
    /**
     * Performance related logging
     */
    LogKind["Performance"] = "Performance";
    /**
     * Interface kind is dedicated for module's logging of interfacing informations.
     * To improve interoperability and debugging.
     */
    LogKind["Interface"] = "Interface";
    /**
     * Logs dedicated to availability.
     */
    LogKind["Availability"] = "Availability";
    /**
     * Logs dedicated to availability.
     */
    LogKind["Reliability"] = "Reliability";
})(LogKind || (LogKind = {}));
/*
this enumeration is used to categorize client logs in kusto to help with data mining, reporting and querying logs
*/
export var LogCategory;
(function (LogCategory) {
    LogCategory["ClientInfo"] = "ClientInfo";
    LogCategory["ClientError"] = "ClientError";
    /**
     * logs related to Engagement/Analytics
     */
    LogCategory["ClientAnalytics"] = "ClientAnalytics";
    /**
     * Logs related to Performance
     */
    LogCategory["ClientPerformance"] = "ClientPerformance";
    /**
     * Logs related to availability.
     */
    LogCategory["ClientAvailability"] = "ClientAvailability";
    /*
    Logs related to reliability
    */
    LogCategory["ClientReliability"] = "ClientReliability";
})(LogCategory || (LogCategory = {}));
/**
 * A type guard to check if the log is a info log
 *
 * @param option a ILogOptions
 */
export function isInfo(option) {
    return option.type === LogKind.Info || option.type === LogKind.Interface;
}
/**
 * A type guard to check if the log is a error log
 *
 * @param option a ILogOptions
 */
export function isError(option) {
    return option.type === LogKind.Error;
}
/**
 * A type guard to check if the log is a analytics log
 *
 * @param option a ILogOptions
 */
export function isAnalytics(option) {
    return option.type === LogKind.Analytics;
}
/**
 * A type guard to check if the log is a performance log
 *
 * @param option a ILogOptions
 */
export function isPerformance(option) {
    return option.type === LogKind.Performance;
}
/**
 * A type guard to check if the log is an availability log
 *
 * @param option a ILogOptions
 */
export function isAvailability(option) {
    return option.type === LogKind.Availability;
}
/**
 * A type guard to check if the log is an reliability log
 *
 * @param option a ILogOptions
 */
export function isReliability(option) {
    return option.type === LogKind.Reliability;
}
